/**
 * AI CONTEXT: routing - Automatic scroll restoration on route changes
 * Journal: J-20250117-01
 * 
 * Purpose:
 * - Automatically scroll to top when navigating between pages
 * - Prevent viewport from maintaining previous page's scroll position
 * - Improve user experience by ensuring new pages start at the top
 * 
 * Implementation:
 * - Uses useEffect with location dependency to detect route changes
 * - Scrolls to top smoothly using window.scrollTo
 * - Handles both programmatic navigation and browser back/forward
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when pathname changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null; // This component doesn't render anything
};

export default ScrollToTop;
